import { groupBy } from 'lodash';

import { ClausesParams, getAllClauses } from '../methods/document';

export const getAllClausesGrouped = async (params: ClausesParams) => {
  const data = await getAllClauses(params);
  const clausesGroupedByName = groupBy(data.results, 'title');
  return Object.keys(clausesGroupedByName).map((key) => ({
    name: key,
    content: clausesGroupedByName[key],
  }));
};
